import { toast } from "react-toastify";
export const { error, success, info, warning }: any = toast;

const toastType: any = { error, success, info, warning }

export const handleToast = (content: string, type?: any) => {
  toast.dismiss();
  type = toastType[type] ? toastType[type] : toastType["error"];
  type(content)
}